import * as Lucide from "lucide-react";
import { mediaUrl } from "@/lib/format";
import { categoryImage, hasCategoryImage } from "@/lib/categoryImages";
import { useCategoryMeta, categoryIconName } from "@/lib/categoryMeta";

// Renders a service thumbnail:
// 1) an uploaded image, else 2) a bundled on-brand category illustration,
// else 3) a clean icon tile using the category's admin-chosen Lucide icon.
export function CategoryThumb({ imageUrl, category, className = "", imgClassName = "object-cover w-full h-full", tileClassName = "w-full h-full min-h-[7rem]", testid }) {
  const meta = useCategoryMeta();
  const uploaded = imageUrl ? mediaUrl(imageUrl) : null;
  const illustration = !uploaded && hasCategoryImage(category) ? categoryImage(category) : null;
  const src = uploaded || illustration;

  if (src) {
    return (
      <img
        src={src}
        alt={category || "service"}
        data-testid={testid}
        onError={(e) => { e.target.onerror = null; e.target.src = categoryImage(category); }}
        className={imgClassName}
      />
    );
  }

  const name = categoryIconName(meta, category);
  const Icon = Lucide[name] || Lucide.Tag;
  return (
    <div data-testid={testid} className={`flex items-center justify-center bg-[#FAF7F2] ${tileClassName} ${className}`}>
      <Icon className="w-14 h-14 text-primary" strokeWidth={1.4} />
    </div>
  );
}
